import React from 'react';
import { AppAndInstanceSwitcherContext } from '@context';

type UseDynamicApiKeys = {
  showKeysVisibilityToggle: boolean;
  codeWithVisibleKeys: string;
  codeWithHiddenKeys: string;
};

const TEMPLATES = {
  PUB_KEY: '{{pub_key}}',
  SECRET_KEY: '{{secret}}'
} as const;

const PROD_HIDDEN = `sk_live_••••••••••••••••••••••••••••••••••`;
const DEV_HIDDEN = `sk_test_••••••••••••••••••••••••••••••••••`;
export function useDynamicApiKeys(code: string): UseDynamicApiKeys {
  const { currentInstance } = React.useContext(AppAndInstanceSwitcherContext);
  const [codeWithVisibleKeys, setCodeWithVisibleKeys] = React.useState('');
  const [codeWithHiddenKeys, setCodeWithHiddenKeys] = React.useState('');
  const secretHidden =
    currentInstance?.environment_type === 'production'
      ? PROD_HIDDEN
      : DEV_HIDDEN;
  const hasTemplate =
    code.includes(TEMPLATES.PUB_KEY) || code.includes(TEMPLATES.SECRET_KEY);

  const pubKeyRegex = new RegExp(`${TEMPLATES.PUB_KEY}`, 'g');
  const secretRegex = new RegExp(`${TEMPLATES.SECRET_KEY}`, 'g');

  React.useEffect(() => {
    const pubKey = currentInstance?.publishable_key || 'your_publishable_key';
    const secretKey = currentInstance?.secret_key || 'your_secret_key';
    setCodeWithVisibleKeys(
      code.replace(pubKeyRegex, pubKey).replace(secretRegex, secretKey)
    );

    setCodeWithHiddenKeys(
      code.replace(pubKeyRegex, pubKey).replace(secretRegex, secretHidden)
    );
    [code, hasTemplate, currentInstance?.publishable_key];
  });

  return {
    showKeysVisibilityToggle: Boolean(
      currentInstance && code.includes(TEMPLATES.SECRET_KEY)
    ),
    codeWithVisibleKeys,
    codeWithHiddenKeys
  };
}